import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=be5167d4&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be5167d4')) {
      api.createRecord('be5167d4', component.options)
    } else {
      api.reload('be5167d4', component.options)
    }
    module.hot.accept("./Widget.vue?vue&type=template&id=be5167d4&", function () {
      api.rerender('be5167d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/TouchPointInfo/Widget.vue"
export default component.exports